import {useCallback} from "react";

/**
 * useSmoothScroll
 * @param {React.RefObject} ref - ref элемента к которому скролим
 * @param {number} offset - смещение в пикселях (отрицательное или положительное)
 * @returns {function} scrollTo
 */
export function useSmoothScroll(ref, offset = 0) {
    const scrollTo = useCallback(() => {
        if (!ref.current) return;

        const y = ref.current.getBoundingClientRect().top + window.pageYOffset + offset;

        window.scrollTo({
            top: y,
            behavior: "smooth",
        });
    }, [ref, offset]);

    return scrollTo;
}
